import { render } from "./ViewerThumbnailGallery.vue?vue&type=template&id=86901558&ts=true"
import script from "./ViewerThumbnailGallery.vue?vue&type=script&lang=ts"
export * from "./ViewerThumbnailGallery.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__